import React from "react";
import "./PortalLogo.css";

export default function PortalLogo({ variant }) {
  return (
    <div className={`portal-logo ${variant || ""}`}>
      {/* <div className="logo-icon">
        <div className="roof"></div>
        <div className="house"></div>
        <div className="accent"></div>
      </div> */}

      <div className="logo-text">
        <div className="logo-main">CFP</div>
        <div className="logo-sub">ENTERPRISE TASK HUB</div>
      </div>
    </div>
  );
}
